"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactRouterDom = require("react-router-dom"),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _Input = _interopRequireDefault(require("../../Input")),
    _ContentLoader = _interopRequireDefault(require("../../ContentLoader")),
    _BreadCrumbs = _interopRequireDefault(require("../../BreadCrumbs")),
    _Text = _interopRequireDefault(require("../../Text"));

require("../styles/_title-box.scss");

function renderSubTitle(a, b, c, d) {
  if (!a) return null;
  var e = a || b ? _react["default"].createElement(_Text["default"], {
    className: "title-box__subtitle",
    placeholder: !0,
    noMargin: !0,
    darkTheme: d
  }, a) : null;
  return c ? _react["default"].createElement(_reactRouterDom.Link, {
    className: (0, _classnames["default"])("title-box__subtitle-link", {
      "title-box__subtitle-link--dark-mode": d
    }),
    to: c
  }, e) : e;
}

function getTitle(a) {
  var b = a.editableTitle,
      c = a.loading,
      d = a.darkMode,
      e = a.title,
      f = a.onBlurTitle,
      g = a.onChangeTitle,
      h = a.titlePlaceHolder;
  return c ? _react["default"].createElement(_ContentLoader["default"], {
    className: "title-box__title-loader",
    height: 100,
    width: 1e3
  }, _react["default"].createElement("rect", {
    x: "0",
    y: "0",
    rx: 8,
    ry: 8,
    width: 1e3,
    height: 100
  })) : b ? _react["default"].createElement(_Input["default"], {
    className: "title-box__input",
    type: "SECONDARY",
    defaultValue: e,
    onBlur: f,
    onChange: g,
    placeholder: h,
    id: "title-box-input",
    prefix: "edit",
    autoGrow: !0
  }) : _react["default"].createElement(_Text["default"], {
    heading3: !0,
    noMargin: !0,
    ellipsisOverflow: !0,
    darkTheme: d
  }, e);
}

function TitleBox(a) {
  var b = a.title,
      c = a.breadCrumbs,
      d = a.subtitle,
      e = a.subtitleLink,
      f = a.alwaysShowSubtitle,
      g = a.darkMode,
      h = a.titleSuffixIcon,
      i = a.titleSuffix;
  return d && c && console.warn("Both Breadcrumbs and a subtitle passed as props to TitleBox. Ignoring subtitle."), _react["default"].createElement("div", {
    className: "title-box"
  }, c ? _react["default"].createElement(_BreadCrumbs["default"], {
    items: c,
    darkMode: g
  }) : renderSubTitle(d, f, e, g), _react["default"].createElement("div", {
    className: "title-box__container"
  }, _react["default"].createElement("div", {
    className: "title-box__suffix-icon-wrapper"
  }, getTitle(a), h && b && _react["default"].createElement(_Icon["default"], {
    name: h,
    className: "title-box__suffix-icon",
    size: 20,
    color: g ? "white" : "black"
  }), i && b ? _react["default"].createElement("div", {
    className: "title-box__suffix"
  }, i) : null)));
}

TitleBox.displayName = "TitleBox", TitleBox.defaultProps = {
  editableTitle: !1,
  darkMode: !1
};

var _default = (0, _react.memo)(TitleBox);

exports["default"] = _default;